<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <ng-container *ngIf="tools">
            <app-tree [isMaterial]="false"
                      emptyMessage="{{'admin.lifts.batches.noToolsSelected' | translate}}"
                      [(items)]="treeDisplayTools"
            ></app-tree>
        </ng-container>
    </div>
    <div class="modal-footer" modal-footer>
        <div class="batches"
             *ngIf="areToolsSelected"
             [formGroup]="batchSelectionForm">
            <ng-container *ngFor="let batch of batches">
                <p-radioButton (onClick)="onCreateNewBatchSelected(false)" name="id"
                               formControlName="id" value="{{batch.id}}"
                               label="{{batch.name}}"></p-radioButton>
            </ng-container>
            <p-radioButton (onClick)="onCreateNewBatchSelected(true)" name="id"
                           formControlName="id" value="-1"
                           label="Create new Batch"></p-radioButton>
            <app-input *ngIf="newBatchSelected"
                       formControlName="name"
                       labelAlign="left"
                       placeholder="{{'admin.lifts.batches.batchName' | translate }}">
            </app-input>
        </div>
        <div class="buttons">
            <app-input-switch *ngIf="areToolsSelected"
                              [formControl]="batchSelectionForm.controls['withStorage']"
                              [inline]="true"
                              onLabel="{{'generic.yes' | translate}}"
                              offLabel="{{'generic.no' | translate}}"
                              topLabel="{{'admin.lifts.batches.addToolsWithStorage' | translate}}"></app-input-switch>
            <app-button *ngIf="areToolsSelected && newBatchSelected"
                        type="primary"
                        class="create"
                        [disabled]="isLoading"
                        (click)="createNewBatch()">
                {{ 'admin.lifts.batches.createNewBatchButton' | translate }}
            </app-button>
            <app-button *ngIf="areToolsSelected && !newBatchSelected"
                        type="primary"
                        class="create"
                        [disabled]="isLoading"
                        (click)="addToolsToBatch()">
                {{ 'admin.lifts.batches.addToolsToBatch' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
